<template>
  <v-app>
    <div style="background-color: white; width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: 10%;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="padding-left: 15px; padding-top: 10px; vertical-align: top;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getCompanySetting('CompanySettings', 'CompanyAddress')}}</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="min-width: 35%; max-width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Statement Num</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.paystatementnum }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Statement Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.paystatementdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%">
        <tr>
          <td><div style="text-align: center;"><h4 class="ma-0"><b>{{ initvalue.paystatementtype }}</b></h4></div></td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%;">
        <tr>
          <td style="width:45%; padding-left: 15px;">
            <div style=" text-align: start; margin: 0;">
              <span style="font-size: 11pt; font-weight: bold; text-align: start;">Employee</span>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.paystatementname }}</p>
              <p style="margin-top: 0;margin-bottom: 0;" v-html="`${initvalue.paystatementaddress!=null ? initvalue.paystatementaddress.replaceAll('\n', '<br>') : ''}`"></p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.paystatementphone }}</p>
            </div>          
          </td>
          <td>&nbsp;</td>
          <td style="width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Period Start</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date( initvalue.paystatementstartdate ).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Period End</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(initvalue.paystatementenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Payment Method</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.paymethod }}</span></td>
              </tr>
              <tr v-if="isDualCurrency==true">
                <td><span style="font-size: 11pt; font-weight: bold">Currency Rate</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.currencyRate }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 7px; padding-bottom: 7px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th :style="css['row-top-left']" colspan="2" width="44%"><span style="font-size: 12pt; margin-left:10px; "><strong>Additions</strong></span></th>
            <th :style="css['row-top-right']" v-if="isDualCurrency==true">{{ initvalue.secondaryCurrency }}</th>
            <th :style="css['row-top-right']" width="16%">Current</th>
            <th :style="css['row-top-right']" width="16%">Year to Date</th>
            <th :style="css['row-top-right']" width="8%">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, index) in data_addition"  v-bind:key="trans._id">
            <td :style="css['row-left-mr']" width="2%">{{ index + 1 }}</td>
            <td :style="css['row-left-mr']" width="42%">{{ trans.transdesc }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ trans.transnote }}</td>
            <td :style="css['row-right-ml']" width="16%" v-if="isDualCurrency==true">{{ trans.transcredit2.toFixed(0) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ trans.transcredit.toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ ((trans.transcredit) + data_addition_ytd(trans) ).toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="8%">&nbsp;</td>
          </tr>
          <tr><td colspan="6" style="height: 7px;"></td></tr>
          <tr>
            <td :style="css['row-bottom-left']" width="2%"><span style="font-size: 11pt;"></span></td>
            <td :style="css['row-bottom-right']" width="42%"><span style="white-space:nowrap; margin-left:8px; "><strong>Gross Pay:</strong></span></td>
            <td :style="css['row-bottom-right']" width="16%" v-if="isDualCurrency==true"><span style="font-size: 11pt;">{{ sum_additions2.toFixed(0) }}</span></td>
            <td :style="css['row-bottom-right']" width="16%"><span style="font-size: 11pt;">{{ sum_additions.toFixed(2) }}</span></td>
            <td :style="css['row-bottom-right']" width="16%"><span style="font-size: 11pt;">{{ sum_additions_ytd.toFixed(2) }}</span></td>
            <td :style="css['row-bottom-right']" width="8%">{{ initvalue.primaryCurrency }}</td>
          </tr>
        </tbody>
      </table>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th :style="css['row-top-left']" width="44%" colspan="2"><span style="font-size: 12pt; margin-left:10px; "><strong>Deductions</strong></span></th>
            <th :style="css['row-top-right']" width="16%" v-if="isDualCurrency==true">{{ initvalue.secondaryCurrency }}</th>
            <th :style="css['row-top-right']" width="16%">Current</th>
            <th :style="css['row-top-right']" width="16%">Year to Date</th>
            <th :style="css['row-top-right']" width="8%">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, index) in data_deduction"  v-bind:key="trans._id">
            <td :style="css['row-left-mr']" width="2%">{{ index + 1 }}</td>
            <td :style="css['row-left-mr']" width="42%">{{ trans.transdesc }}&nbsp;&nbsp;{{ trans.transnote }}</td>
            <td :style="css['row-right-ml']" width="16%" v-if="isDualCurrency==true">{{ trans.transdebit2.toFixed(0) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ trans.transdebit.toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ ((trans.transdebit) + data_deduction_ytd(trans)).toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="8%">&nbsp;</td>
          </tr>
          <tr><td colspan="6" style="height: 7px;"></td></tr>
          <tr>
            <td :style="css['row-bottom-left']" width="2%"><span style="font-size: 11pt;"></span></td>
            <td :style="css['row-bottom-right']" width="42%"><span style="white-space:nowrap; margin-left:8px; "><strong>Total Deductions:</strong></span></td>
            <td :style="css['row-bottom-right']" width="16%" v-if="isDualCurrency==true"><span style="font-size: 11pt;">{{ sum_deductions2.toFixed(0) }}</span></td>
            <td :style="css['row-bottom-right']" width="16%"><span style="font-size: 11pt;">{{ sum_deductions.toFixed(2) }}</span></td>
            <td :style="css['row-bottom-right']" width="16%"><span style="font-size: 11pt;">{{ sum_deductions_ytd.toFixed(2) }}</span></td>
            <td :style="css['row-bottom-right']" width="8%">&nbsp;</td>
          </tr>
          <tr>
            <td :style="css['row-none-left']" width="2%"><span style="font-size: 11pt;">&nbsp;</span></td>
            <td :style="css['row-none-right']" width="42%"><span style="white-space:nowrap; margin-left:8px; font-weight: 600;"><strong>NET PAY:</strong></span></td>
            <td :style="css['row-none-right']" width="16%" v-if="isDualCurrency==true"><span style="font-size: 11pt; font-weight: 600;">{{ (sum_additions2 - sum_deductions2).toFixed(0) }}</span></td>
            <td :style="css['row-none-right']" width="16%"><span style="font-size: 11pt; font-weight: 600;">{{ (sum_additions - sum_deductions).toFixed(2) }}</span></td>
            <td :style="css['row-none-right']" width="16%"><span style="font-size: 11pt; font-weight: 600;">{{ (sum_additions_ytd - sum_deductions_ytd).toFixed(2) }}</span></td>
            <td :style="css['row-none-right']" width="8%">{{ initvalue.primaryCurrency }}</td>
          </tr>
        </tbody>
      </table>
      <div style="padding-bottom: 10px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th :style="css['row-top-left']" width="44%" colspan="2"><span style="font-size: 12pt; margin-left:10px; "><strong>Employer Contributions</strong></span></th>
            <th :style="css['row-top-right']" width="16%" v-if="isDualCurrency==true">{{ initvalue.secondaryCurrency }}</th>
            <th :style="css['row-top-right']" width="16%">Current</th>
            <th :style="css['row-top-right']" width="16%">Year to Date</th>
            <th :style="css['row-top-right']" width="8%">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, index) in data_contribution"  v-bind:key="trans._id">
            <td :style="css['row-left-mr']" width="2%">{{ index + 1 }}</td>
            <td :style="css['row-left-mr']" width="42%">{{ trans.transdesc }}&nbsp;&nbsp;{{ trans.transnote }}</td>
            <td :style="css['row-right-ml']" width="16%" v-if="isDualCurrency==true">{{ trans.transcredit2.toFixed(0) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ trans.transcredit.toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ ((trans.transcredit) + data_contribution_ytd(trans)).toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="8%">&nbsp;</td>
          </tr>
          <tr><td colspan="6" style="border-bottom: 3px solid; height: 10px;"></td></tr>
        </tbody>
      </table>
      <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th :style="css['row-top-left']" width="44%" colspan="2"><span style="font-size: 12pt; margin-left:10px; "><strong>Paid Leave</strong></span></th>
            <th :style="css['row-top-right']" width="16%">Increase</th>
            <th :style="css['row-top-right']" width="16%">Decrease</th>
            <th :style="css['row-top-right']" width="16%">Balance</th>
            <th :style="css['row-top-right']" width="8%">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="data_benefit.length>0">
          <tr v-for="(trans, index) in data_benefit"  v-bind:key="trans._id">
            <td :style="css['row-left-mr']" width="2%">{{ index + 1 }}</td>
            <td :style="css['row-left-mr']" width="42%">{{ trans.transdesc }}&nbsp;&nbsp;{{ getTransactionString(trans._id) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ getCreditAmountByAccount(trans._id).toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ getDebitAmountByAccount(trans._id).toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ (calculateBalanceByAccount(trans._id) + parseFloat((trans.transcredit - trans.transdebit).toFixed(2)) ).toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="8%">&nbsp;</td>
          </tr>
          <tr><td colspan="6" style="border-bottom: 3px solid; height: 7px;"></td></tr>
        </tbody>
        <tbody v-else>
          <tr v-for="(trans, index) in benefit_sum.filter(trans=>trans.transsubtype=='Benefit')"  v-bind:key="trans._id">
            <td :style="css['row-left-mr']" width="2%">{{ index + 1 }}</td>
            <td :style="css['row-left-mr']" width="42%">{{ trans.transdesc }}&nbsp;&nbsp;{{ getTransactionString(trans.accountid) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ trans.transcredit.toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ trans.transdebit.toFixed(2)  }}</td>
            <td :style="css['row-right-ml']" width="16%">{{ (calculateBalanceAll(trans.accountid) + parseFloat((trans.transcredit - trans.transdebit).toFixed(2))  ).toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="8%">&nbsp;</td>
          </tr>
          <tr><td colspan="6" style="border-bottom: 3px solid; height: 7px;"></td></tr>
        </tbody>
      </table>
      <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
      <table v-if="isHaveSaving()==true" style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th :style="css['row-top-left']" width="44%" colspan="2"><span style="font-size: 12pt; margin-left:10px; "><strong>Flexible Savings Account</strong></span></th>
            <th :style="css['row-top-right']" width="16%">Increase</th>
            <th :style="css['row-top-right']" width="16%">Decrease</th>
            <th :style="css['row-top-right']" width="16%">Balance</th>
            <th :style="css['row-top-right']" width="8%">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, index) in saving_sum"  v-bind:key="trans._id">
            <td :style="css['row-left-mr']" width="2%">{{ index + 1 }}</td>
            <td :style="css['row-left-mr']" width="42%">{{ trans.transnote }}</td>
            <td :style="css['row-right-ml']" width="16%" style="text-align: right">{{ trans.transcredit!=undefined ? trans.transcredit.toFixed(2) : '' }}</td>
            <td :style="css['row-right-ml']" width="16%" style="text-align: right">{{ trans.transdebit!=undefined ? trans.transdebit.toFixed(2) : ''  }}</td>
            <td :style="css['row-right-ml']" width="16%" style="text-align: right">{{ trans.balance.toFixed(2) }}</td>
            <td :style="css['row-right-ml']" width="8%">&nbsp;</td>
          </tr>
          <tr><td colspan="6" style="border-bottom: 3px solid; height: 7px;"></td></tr>
        </tbody>
      </table>
      <p v-if="initvalue.approval && initvalue.approval.approverid!=null" style="margin-top: 0; margin-bottom: 5px">&nbsp;</p>
      <p v-else style="margin-top: 0; margin-bottom: 40px">&nbsp;</p>
      <table v-if="initvalue.approval && initvalue.approval.approverid!=null" style="width: 250px" cellpadding="0" cellspacing="0">
        <tr>
          <td colspan="2" style="text-align: center; padding-bottom: 0px;"><img :src="initvalue.approval.approvalsignature" :height="60" /></td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: right; border-bottom: 2px; border-bottom-style: solid"></td>
        </tr>
        <tr>
          <td style="text-align: left;"><span style="font-size: 9pt;">{{ initvalue.approval.approvalname }}</span></td>
          <td style="text-align: right;"><span style="font-size: 9pt;">Ref #{{ initvalue.approval.approvalidnum }}</span></td>
        </tr>
      </table>
      <table v-else style="width: 300px" cellpadding="0" cellspacing="0">
        <tr>
          <td style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Electronic document without signature</td>
        </tr>
      </table>
      <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../util/tools';

export default {
  name: 'PrintSalesOrder',
  props: {
    id: String
  },
  data() {
    return {
      logo: null,
      initvalue: {},
      data_company: {},
      isDualCurrency: false,
      benefit_sum: [],
      saving_sum: [],
      css: {
        'row-top-right': 'text-align: right; border-bottom: 1px; border-bottom-style: solid',
        'row-top-left': 'text-align: left; border-bottom: 1px; border-bottom-style: solid',
        'row-left-mr': 'vertical-align: top; text-align: left; padding-right: 5px;',
        'row-right-ml': 'vertical-align: top; text-align: right; padding-left: 5px;',
        'row-bottom-right': 'padding: 2px; text-align: right; border-top: 3px; border-top-style: solid;',
        'row-bottom-left': 'padding: 2px; text-align: left; border-top: 3px; border-top-style: solid;',
        'row-none-right': 'padding: 2px; text-align: right;',
        'row-none-left': 'padding: 2px; text-align: left;',
      },
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getPayStatementRequest', 'getCompanyDataRequest']),
    getCompanySetting(code, name){
      if(this.data_company.settings==null || this.data_company.settings.length==0) return '';
      let results = this.data_company.settings.find(setting=>setting.settingcode==code);
      let result = results.settinglists.find(result=>result.settingname==name);
      let value = result!=null ? result.settingvalue : '';
      if(value.trim()=='true') value=true;
      else if(value.trim()=='false') value=false;
      return value;
    },
    data_addition_ytd(trans){
      if(this.initvalue.balance_ytd==null) return 0;
      let find = this.initvalue.balance_ytd.find(x=>x._id==trans.accountid);
      if(find==null) return 0;
      return find.transcredit;
    },
    data_deduction_ytd(trans){
      if(this.initvalue.balance_ytd==null) return 0;
      let find = this.initvalue.balance_ytd.find(x=>x._id==trans.accountid);
      if(find==null) return 0;
      return find.transdebit;
    },
    data_contribution_ytd(trans){
      if(this.initvalue.balance_ytd==null) return 0;
      let find = this.initvalue.balance_ytd.find(x=>x._id==trans.accountid);
      if(find==null) return 0;
      return find.transcredit;
    },
    getTransactionString(accountid){
      if(this.initvalue==null || this.initvalue.transactions==null) return '';
      let transactions = this.initvalue.transactions.filter(trans=>trans.accountid==accountid);
      let strings = transactions.map(trans=>trans.transnote).join(' ');
      return strings;
    },
    getCreditAmountByAccount(accountid){
      if(this.initvalue==null || this.initvalue.transactions==null) return 0;
      let sum = this.initvalue.transactions.filter(trans=>trans.accountid==accountid);
      var credit_list =  sum.map( trans => trans.transcredit!==null ? trans.transcredit : 0 );
      let credit = credit_list.length==0 ? 0 : credit_list.reduce((a,b)=>a+b);
      return credit;
    },
    getDebitAmountByAccount(accountid){
      if(this.initvalue==null || this.initvalue.transactions==null) return 0;
      let sum = this.initvalue.transactions.filter(trans=>trans.accountid==accountid);
      var debit_list =  sum.map( trans => trans.transdebit!==null ? trans.transdebit : 0 );
      let debit = debit_list.length==0 ? 0 : debit_list.reduce((a,b)=>a+b);
      return debit;
    },
    calculateBalanceByAccount(accountid){
      if(this.initvalue==null || this.initvalue.transactions==null) return 0;
      let sum = this.initvalue.transactions.filter(trans=>trans.accountid==accountid);
      var credit_list =  sum.map( trans => trans.transcredit!==null ? trans.transcredit : 0 );
      var debit_list =  sum.map( trans => trans.transdebit!==null ? trans.transdebit : 0 );
      let credit = credit_list.length==0 ? 0 : credit_list.reduce((a,b)=>a+b);
      let debit = debit_list.length==0 ? 0 : debit_list.reduce((a,b)=>a+b);
      return parseFloat((credit-debit).toFixed(2));
    },
    getBenefitSum(){
      let sum=[];
      let transactions = this.initvalue.transactions.filter(trans=>trans.transsubtype=='Benefit');
      for(var i in transactions){
        let trans = transactions[i];
        let found_account = sum.find(x=>x.accountid == trans.accountid);
        if(found_account == undefined){
          let sumcredit = this.getCreditAmountByAccount(trans.accountid);
          let sumdebit = this.getDebitAmountByAccount(trans.accountid);
          sum.push({
            accountid: trans.accountid,
            transcredit: sumcredit,
            transdebit: sumdebit,
            transdesc: trans.transdesc,
            transnote: trans.transnote,
            transsubtype: trans.transsubtype,
          });
        }
      }
      this.benefit_sum = sum;
    },
    getSavingSum(){
      let transactions = this.initvalue.transactions.filter(trans=>trans.transsubtype=='Saving');
      let balance = this.calculateBalanceSaving();
      let opening = {transsubtype: 'Saving', transnote: 'Opening Balance', balance: balance};
      this.saving_sum.push(opening);
      for(var i in transactions){
        let trans = transactions[i];
        balance = balance + trans.transcredit - trans.transdebit;
        trans.balance = balance;
        this.saving_sum.push(trans);
      }
    },
    calculateBalanceSaving(){
      let credit = this.initvalue.balance_all!==null && this.initvalue.balance_all.find(x=>x.transsubtype=='Saving')!==undefined ? this.initvalue.balance_all.find(x=>x.transsubtype=='Saving').transcredit : 0;
      let debit = this.initvalue.balance_all!==null && this.initvalue.balance_all.find(x=>x.transsubtype=='Saving')!==undefined ? this.initvalue.balance_all.find(x=>x.transsubtype=='Saving').transdebit : 0;
      return parseFloat((credit-debit).toFixed(2));
    },
    isHaveSaving(){
      if(this.saving_sum.length==0) return false;
      if(this.saving_sum.length==1) {
        if(this.saving_sum[0].transsubtype=='Saving' && this.saving_sum[0].balance==0) return false;
      }
      return true;
    },
  },
  computed: {
    data_addition(){
      if(this.initvalue==null || this.initvalue.transactions==null) return [];
      let result = this.initvalue.transactions.filter(trans=>trans.transsubtype=='Addition');
      return result;
    },
    data_deduction(){
      if(this.initvalue==null || this.initvalue.transactions==null) return [];
      let result = this.initvalue.transactions.filter(trans=>trans.transsubtype=='Deduction');
      return result;
    },
    data_contribution(){
      if(this.initvalue==null || this.initvalue.transactions==null) return [];
      let result = this.initvalue.transactions.filter(trans=>trans.transsubtype=='Contribution');
      return result;
    },
    data_benefit(){
      if(this.initvalue==null || this.initvalue.balance_all==null || this.initvalue.balance_all.length==0) return [];
      let result = this.initvalue.balance_all.filter(trans=>trans.transsubtype=='Benefit');
      return result;
    },

    sum_additions(){
      if(this.initvalue==null || this.initvalue.transactions==null) return 0;
      var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Addition' ? trans.transcredit : 0 );
      return list.reduce((a,b)=>a+b);
    },
    sum_additions2(){
      if(this.initvalue==null || this.initvalue.transactions==null) return 0;
      var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Addition' ? trans.transcredit2 : 0 );
      return list.reduce((a,b)=>a+b);
    },
    sum_additions_ytd(){
      if(this.initvalue==null || this.initvalue.balance_ytd==null) return 0;
      if(this.initvalue.balance_ytd==null || this.initvalue.balance_ytd.length==0) return this.sum_additions;
      var list =  this.initvalue.balance_ytd.map( trans => trans.transsubtype=='Addition' ? trans.transcredit : 0 );
      return this.sum_additions + list.reduce((a,b)=>a+b);
    },
    sum_deductions(){
      if(this.initvalue==null || this.initvalue.transactions==null) return 0;
      var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit : 0  );
      return list.reduce((a,b)=>a+b);
    },
    sum_deductions2(){
      if(this.initvalue==null || this.initvalue.transactions==null) return 0;
      var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit2 : 0  );
      return list.reduce((a,b)=>a+b);
    },
    sum_deductions_ytd(){
      if(this.initvalue.balance_ytd==null || this.initvalue.balance_ytd.length==0) return this.sum_deductions;
      var list =  this.initvalue.balance_ytd.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit : 0 );
      return this.sum_deductions + list.reduce((a,b)=>a+b);
    },


    data_location(){
      if(this.data_company.locations==null || this.data_company.locations.length==0) return null;
      let location = this.data_company.locations.find(i=>i._id == this.initvalue.locationid);
      if(location!=null) return location['locationname'];
      return '';
    },
    data_user(){
      if(this.data_company.users==null || this.data_company.users.length==0) return null;
      let user = this.data_company.users.find(i=>i._id == this.initvalue.userid);
      if(user!=null) return user['username'];
      return '';
    },
    data_paymethod(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.length==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod;
      return null;
    },
    data_paymethod_name(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.length==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod['paymethodname'];
      return null;
    }
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getPayStatementRequest(this.id);
      this.isDualCurrency = this.initvalue.isDualCurrency;
      if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.getBenefitSum();
      this.getSavingSum();
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
    }
  },
}

</script>

<style src="./Print.scss" lang="scss"/>
